// Объединяем только выполняющиеся запросы; завершённые ответы не кэшируем.
// При смене фильтра устаревший ответ не должен перезаписывать общий Vuex state.
export function createLatestRequest() {
  const inFlight = new Map();
  let latestKey;

  return (key, execute) => {
    latestKey = key;
    if (inFlight.has(key)) return inFlight.get(key);

    const request = Promise.resolve()
      .then(() => execute(() => latestKey === key))
      .finally(() => inFlight.delete(key));
    inFlight.set(key, request);
    return request;
  };
}
